/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkMilkIcon16Light } from './FoodDrinkMilkIcon16Light';
import { FoodDrinkMilkIcon16Regular } from './FoodDrinkMilkIcon16Regular';
import { FoodDrinkMilkIcon16Solid } from './FoodDrinkMilkIcon16Solid';
import { FoodDrinkMilkIcon20Light } from './FoodDrinkMilkIcon20Light';
import { FoodDrinkMilkIcon20Regular } from './FoodDrinkMilkIcon20Regular';
import { FoodDrinkMilkIcon20Solid } from './FoodDrinkMilkIcon20Solid';
import { FoodDrinkMilkIcon24Regular } from './FoodDrinkMilkIcon24Regular';
import { FoodDrinkMilkIcon24Solid } from './FoodDrinkMilkIcon24Solid';
import { FoodDrinkMilkIcon32Regular } from './FoodDrinkMilkIcon32Regular';
import { FoodDrinkMilkIcon64Regular } from './FoodDrinkMilkIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkMilkIcon16Light,
        regular: FoodDrinkMilkIcon16Regular,
        solid: FoodDrinkMilkIcon16Solid,
    },
    20: {
        light: FoodDrinkMilkIcon20Light,
        regular: FoodDrinkMilkIcon20Regular,
        solid: FoodDrinkMilkIcon20Solid,
    },
    24: {
        regular: FoodDrinkMilkIcon24Regular,
        solid: FoodDrinkMilkIcon24Solid,
    },
    32: {
        regular: FoodDrinkMilkIcon32Regular,
    },
    64: {
        regular: FoodDrinkMilkIcon64Regular,
    },
};
export var FoodDrinkMilkIcon = forwardRef('FoodDrinkMilkIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
